const MuiDivider = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      backgroundColor: theme.palette.grey[300],
      borderColor: theme.palette.grey[300]
    })
  }
};
export default MuiDivider;